import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { IDischarge, IDrainageTrench, ILoad, IPhaseOneOutput, IProject, IProjectInfo, ISlope, ISoilInputData } from '../../shared/iProject';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';

const initialState: IReduxState<IProject> = {
    status: EReduxState.initialState,
};

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        cleanProject: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setProject: (state, action: PayloadAction<IProject>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
        setProjectInfo: (state, action: PayloadAction<IProjectInfo>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data, projectInfo: action.payload };
        },
        setSlope: (state, action: PayloadAction<ISlope>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, slope: action.payload };
        },
        setLoad: (state, action: PayloadAction<ILoad>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, load: action.payload };
        },
        setSoilInputData: (state, action: PayloadAction<ISoilInputData>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, soilInputData: action.payload };
        },
        setDischarge: (state, action: PayloadAction<IDischarge>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, discharge: action.payload };
        },
        setDrainageTrenches: (state, action: PayloadAction<IDrainageTrench[]>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, drainageTrenches: action.payload };
        },
        setPhaseOneOutputCalculation: (state, action: PayloadAction<IPhaseOneOutput>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data!, phaseOneOutputs: action.payload };
        },
    },
});

export const { setPhaseOneOutputCalculation, setProjectInfo, setProject, cleanProject, setSlope, setLoad, setSoilInputData, setDischarge, setDrainageTrenches } = projectSlice.actions;

export const selectProject = (state: RootState) => state.project;

export default projectSlice.reducer;
